import { Flex, Icon, View } from '~/components'
import { css, styled } from '~/lite'

export const RowFlex = styled(Flex)<{ $icon: boolean; $loading: boolean }>`
  flex-direction: row;
  align-items: center;
  justify-content: center;
  pointer-events: ${({ $loading }) => ($loading ? 'none' : 'auto')};

  ${({ $icon }) =>
    $icon &&
    css`
      .uppy-FileInput-btn {
        width: 40px;
        height: 40px;
        min-width: 0;
        overflow: hidden;
        opacity: 0;
      }
    `}
`

export const EditIcon = styled(Icon)`
  position: absolute;
  top: 4px;
  right: 4px;
  bottom: 4px;
  left: 4px;
  width: auto;
  height: auto;
`

export const LoaderContainer = styled(View)`
  position: absolute;
  top: 8px;
  right: 8px;
  bottom: 8px;
  left: 8px;
  width: auto;
  height: auto;
  z-index: 1;
  pointer-events: none;
  align-items: center;
  justify-content: center;
  background: ${props => props.theme.primary};
`

export const InputLoaderContainer = styled(View)`
  position: absolute;
  top: 3px;
  right: 3px;
  bottom: 3px;
  left: 3px;
  width: auto;
  height: auto;
  z-index: 1;
  pointer-events: none;
  align-items: center;
  justify-content: center;
  background: ${props => props.theme.inputBorderColor};
`
